import React from 'react';

const ItemsContainer = ({ data }) => {
    return (
        <div className="">
            <div className="">
                <div className="uploaded-items-container pb-3 px-3 d-none d-lg-block">
                    <div style={{ borderBottom: '1px solid #46A4F2', backgroundColor: '#F6F6F6' }} className="d-flex justify-content-around align-items-center py-3 sticky-top">
                        <div style={{ fontSize: '12px' }} className="col-md-1 text-brand fw-bold ps-2">Code</div>
                        <div style={{ fontSize: '12px' }} className="col-md-5 text-brand fw-bold ps-2">Product Name</div>
                        <div style={{ fontSize: '12px' }} className="col-md-3 text-brand fw-bold text-center">Closing Stock</div>
                        <div style={{ fontSize: '12px' }} className="col-md-3 text-brand fw-bold text-center">Next Day Demand</div>
                    </div>

                    {
                        data.map(product =>
                            <div key={product.code} className="d-flex justify-content-between align-items-center">
                                <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-1 fw-bold py-2 ps-2">{product.code}</div>
                                <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-5 fw-bold p-2">{product.name}</div>
                                <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-3 fw-bold py-2 text-center">{product.stock}</div>
                                <div style={{ fontSize: '12px' }} className="col-md-3 fw-bold py-2 text-center">{product.demand}</div>
                            </div>)
                    }
                </div>

                <div className="uploaded-items-container-sm d-lg-none">
                    <div style={{ borderBottom: '1px solid #46A4F2', backgroundColor: '#F6F6F6' }} className="d-flex justify-content-between align-items-center py-2 sticky-top">
                        <div style={{ fontSize: '12px' }} className="col-8 text-brand fw-bold ps-2">Article</div>
                        <div style={{ fontSize: '9px' }} className="col-2 text-brand fw-bold text-center">Closing Stock</div>
                        <div style={{ fontSize: '9px' }} className="col-2 text-brand fw-bold text-center">Next Day Demand</div>
                    </div>

                    {
                        data.map(product =>
                            <div key={product.code} className="d-flex justify-content-between align-items-center">
                                <div style={{ borderRight: '1px solid #46A4F2', fontSize: '11px' }} className="col-8 fw-bold ps-2">
                                    <i><small style={{ fontSize: '10px', color: '#6d9dd5' }}>{product.code}</small></i>
                                    <br /><b>{product.name}</b>
                                </div>

                                <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-2 fw-bold py-2 text-center">{product.stock}</div>
                                
                                <div style={{ fontSize: '12px' }} className="col-2 fw-bold py-2 text-center">{product.demand}</div>
                            </div>)
                    }
                </div>
            </div>
        </div>
    );
};

export default ItemsContainer;